import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';  
import { RouterModule, Routes } from '@angular/router';
import { AuditComponent } from './audit.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { ChecklistComponent } from './checklist/checklist.component';

import { AssignedAuditComponent } from './assigned-audit/assigned-audit.component';
import { AuthGuard } from '../services/auth/auth.guard';
import { AssignedAuditedSocietiesComponent } from './assigned-audited-societies/assigned-audited-societies.component';
import { AssignVerifierComponent } from './assign-verifier/assign-verifier.component';
import { SocitiesListForAuditVerificationComponent } from './socities-list-for-audit-verification/socities-list-for-audit-verification.component';
import { ViewSocietyDetailComponent } from './view-society-detail/view-society-detail.component';
import { AddNewMemberComponent } from './add-new-member/add-new-member.component';
import { FinalChecklistComponent } from './final-checklist/final-checklist.component';
import { ViewchecklistComponent } from './viewchecklist/viewchecklist.component';
import { userAccessGuard } from '../services/auth/guards/user-access.guard';
import { AuditFeesComponent } from './audit-fees/audit-fees.component';
import { AllotDepartmentAuditComponent } from './allot-department-audit/allot-department-audit.component';
import { PreviewAuditComponent } from './preview-audit/preview-audit.component';
import { ChecklistStatusModalComponent } from './checklist-status-modal/checklist-status-modal.component';
import { RaiseAuditRequestComponent } from './raise-audit-request/raise-audit-request.component';


const routes: Routes = [
  {
    path: "",
    data: {
      title: "Audit",     
      urls: [{ title: "Audit", url: "/audit" }, { title: "Audit" }],
    },
    component: AuditComponent,
  },
  {
    path: 'assigned-audit/:id',
  //  canActivate: [AuthGuard,userAccessGuard],
    component: AssignedAuditComponent
  },
  {
    path: "checklist/:iSocietyDetailsId", 
  //  canActivate: [AuthGuard,userAccessGuard],
    component: ChecklistComponent, 
    data: {
      title: "Checklist",        
    },
  },
  {
    path: 'assignedsociety/:id', 
 //   canActivate: [AuthGuard,userAccessGuard], 
    component: AssignedAuditedSocietiesComponent 
  },
  {
    path: 'assignverifier/:isocietydetailsid/:transId', 
    //canActivate: [AuthGuard,userAccessGuard], 
    component: AssignVerifierComponent 
  },
  {
    path: 'auditverification/:id',
 //   canActivate: [AuthGuard,userAccessGuard], 
    component: SocitiesListForAuditVerificationComponent 
  },
  {
    path: 'viewsocietydetails/:isocietydetailsid',
  //  canActivate: [AuthGuard,userAccessGuard],
    component: ViewSocietyDetailComponent
  },
  {
    path: 'addmember',
   canActivate: [AuthGuard],
    component: AddNewMemberComponent
  },
  {
    path: "final-checklist/:iSocietyDetailsId/:iSocietyDetailsTransId", 
   // canActivate: [AuthGuard,userAccessGuard],
    component: FinalChecklistComponent, 
    data: {
      title: "FinalChecklist",        
    }
  },
  {
    path: "final-checklist/:iSocietyDetailsId/:iSocietyDetailsTransId", 
    //canActivate: [AuthGuard,userAccessGuard],
    component: FinalChecklistComponent, 
    data: {
      title: "FinalChecklist",        
    }
  },
  {
    path: "view-checklist/:iSocietyDetailsId/:iSocietyDetailsTransId", 
   // canActivate: [AuthGuard,userAccessGuard],
    component: ViewchecklistComponent, 
    data: {
      title: "ViewChecklist",        
    }
  },
  {
    path: "audit-fee", 
   // canActivate: [AuthGuard,userAccessGuard],
    component: AuditFeesComponent, 
    data: {
      title: "AuditFees",        
    }
  },
   {
    path: "allot-dep-audit", 
   // canActivate: [AuthGuard,userAccessGuard],
    component: AllotDepartmentAuditComponent, 
    data: {
      title: "AllotDepartmentAudit",        
    },
    
  },
  {
    path: "auditpreview/:iSocietyDetailsId/:iSocietyDetailsTransId", 
   // canActivate: [AuthGuard,userAccessGuard],
    component: PreviewAuditComponent, 
    data: {
      title: "PreviewAuditComponent",        
    }
  },
    {
    path: "RaiseAuditRequest", 
   // canActivate: [AuthGuard,userAccessGuard],
    component: RaiseAuditRequestComponent, 
    data: {
      title: "RaiseAuditRequestComponent",        
    }
  }
];

@NgModule({

  declarations: 
  [
    AuditComponent, 
    ChecklistComponent,
    AssignedAuditComponent, 
    AssignedAuditedSocietiesComponent,
    AssignVerifierComponent, 
    SocitiesListForAuditVerificationComponent, 
    ViewSocietyDetailComponent, 
    AddNewMemberComponent, FinalChecklistComponent, ViewchecklistComponent,AuditFeesComponent,
     AllotDepartmentAuditComponent, PreviewAuditComponent, ChecklistStatusModalComponent, RaiseAuditRequestComponent
    // NgxPaginationModule
  ],



  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,  
    NgxDatatableModule,
    RouterModule.forChild(routes),
  ] 
})
export class AuditModule {}
